import cssDefaults from '../../assets/stylesheets/bootstrap-variables.scss';

export default function useBoostrapVariables(){
  return cssDefaults;
}
